/**
 * @file The closed list of periods the Analytics page offers: YTD, QTD and
 * MTD, a subset of `ANALYTICS_PERIODS` that leaves out `wtd`, `lastWeek` and
 * `lastMonth`. Consumers:
 * `analyticsView`, which falls back to `ytd` for any other `period` value,
 * and the page's period control.
 */
import type { AnalyticsPeriod } from '#types';

export const ANALYTICS_PAGE_PERIODS = [
  'ytd',
  'qtd',
  'mtd',
] as const satisfies readonly AnalyticsPeriod[];
